import React from "react";
import { Modal } from "react-bootstrap-v5";
import { KTSVG } from "../../../../_start/helpers/components/KTSVG";

interface CreateFolderModalProps {
  show: boolean;
  handleClose: () => void;
  handleCreate: (file: File) => void;
}

export default function UploadFileModal(props: CreateFolderModalProps) {

  const folderName = React.useRef<HTMLInputElement>(null);

  return (
    <Modal
      id="kt_modal_1"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog-centered h-auto"
      show={props.show}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Ordner erstellen</h5>
          <div
            onClick={() => props.handleClose()}
            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <KTSVG
              path="/media/icons/duotone/Navigation/Close.svg"
              className="svg-icon svg-icon-2x"
            />
          </div>
        </div>
        <div className="modal-body">
          <div className="mb-10">
            <label className="form-label">Datei auswaehlen:</label>
            <input
              ref={folderName}
              type="file"
              className="form-control"
              placeholder="z.B. Daten"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            data-bs-dismiss="modal"
            onClick={() => props.handleClose()}
          >
            Schliessen
          </button>
          <button
            onClick={() => props.handleCreate(folderName!.current!.files![0])}
            type="button"
            className="btn btn-primary"
          >
            Hochladen
          </button>
        </div>
      </div>
    </Modal>
  );
}
